//@flow
import React from "react"
import { connect } from "react-redux"
import { replace, push } from "react-router-redux"
import { compose } from "react-apollo"
import { Helmet } from "react-helmet"
import {
  EntityHeading,
  EntityDetail,
  Entity,
  EntityAction,
  EntityPrimaryLink
} from "../UI/EntityList"
import { parseQueryString } from "../RoutingHelpers"
import { SearchTableView } from "../SearchTableView"
import queries from "./queries"
import type { AttractLoopListViewProps } from "./types"
import { confirmDeletePath } from "./helpers"

type State = { mutationLoading: boolean }

class AttractLoopListView extends React.Component<
  AttractLoopListViewProps,
  State
> {
  constructor(props) {
    super(props)
    this.state = { mutationLoading: false }
  }

  render() {
    const {
      attractLoops: { attractLoops, loading },
      match,
      replace,
      searchName,
      history: { push }
    } = this.props
    const count = attractLoops ? attractLoops.length : 0
    return (
      <SearchTableView
        url={match.url}
        routerAction={replace}
        entityName="Attract Loops"
        searchName={searchName}
        handleNewClick={() => push(`${match.url}/new`)}
        loading={loading || this.state.mutationLoading}
      >
        <Helmet>
          <title>
            {`${count} Attract Loop${count === 1 ? "" : "s"}${searchName !== ""
              ? ` Matching '${searchName}'`
              : ""}`}
          </title>
        </Helmet>
        <EntityHeading>
          <EntityDetail grow={2}>Title</EntityDetail>
          <EntityDetail grow={1} shrink={0} />
        </EntityHeading>
        {attractLoops &&
          attractLoops.map(attractLoop => (
            <Entity key={attractLoop.id}>
              <EntityDetail grow={2}>
                <EntityPrimaryLink to={`${match.url}/${attractLoop.id}/slides`}>
                  {attractLoop.title}
                </EntityPrimaryLink>
              </EntityDetail>
              <EntityDetail grow={1} shrink={0} row end>
                <EntityAction
                  href="#"
                  onClick={() => push(`${match.url}/${attractLoop.id}`)}
                  icon="✏️"
                />
                <EntityAction
                  href="#"
                  onClick={() => push(confirmDeletePath(attractLoop.id))}
                  icon="❌"
                />
              </EntityDetail>
            </Entity>
          ))}
      </SearchTableView>
    )
  }
}

const AttractLoopsWithData = compose(queries.withAttractLoops)(
  AttractLoopListView
)

export default connect(
  state => ({
    searchName: parseQueryString(state, "name")
  }),
  {
    replace,
    push
  }
)(AttractLoopsWithData)



// WEBPACK FOOTER //
// ./src/AttractLoops/AttractLoopListView.js